import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API, FeUtil } from '../../../hezky-routes';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private feUtil: FeUtil) { }

  login(payload: any): Observable<any> {
    return this.feUtil.httpSvc.post(API.AUTH.LOGIN, payload);
  }

  generateOTP(payload: { customer_id: number, email: string }): Observable<any> {
    return this.feUtil.httpSvc.post(API.AUTH.GENERATE_OTP, payload)
  }

  verifyOTP(payload: any): Observable<any> {
    return this.feUtil.httpSvc.post(API.AUTH.VERIFY_OTP, payload)
  }

  logout(): Observable<any> {
    return this.feUtil.httpSvc.post(API.AUTH.LOGOUT, {})
  }
}
